var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28878",
    "data-name": "Group 28878",
    transform: "translate(-31 -397)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    transform: "translate(50 397) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.194,0a4,4,0,0,1,3.462,2L20.84,7.5a4,4,0,0,1,0,4.008L17.655,17a4,4,0,0,1-3.462,2H7.806a4,4,0,0,1-3.462-2L1.16,11.5a4,4,0,0,1,0-4.008L4.345,2A4,4,0,0,1,7.806,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.806209564208984 1.5 C 6.917130470275879 1.5 6.088109970092773 1.97797966003418 5.642650604248047 2.747400283813477 L 2.458440780639648 8.247409820556641 C 2.011129379272461 9.02003002166748 2.011129379272461 9.979960441589355 2.458429336547852 10.75259017944336 L 5.64263916015625 16.2525806427002 C 6.088100433349609 17.02202033996582 6.917130470275879 17.5 7.806209564208984 17.5 L 14.19379043579102 17.5 C 15.08287048339844 17.5 15.91189002990723 17.02202033996582 16.35734939575195 16.25259017944336 L 19.54155921936035 10.75257968902588 C 19.98887062072754 9.979960441589355 19.98887062072754 9.020039558410645 19.54155921936035 8.247409820556641 L 16.35734939575195 2.747409820556641 C 15.91189002990723 1.97797966003418 15.08287048339844 1.5 14.19379043579102 1.5 L 7.806209564208984 1.5 M 7.806209564208984 0 L 14.19379043579102 0 C 15.62113952636719 0 16.94034004211426 0.760589599609375 17.65549087524414 1.995859146118164 L 20.83970069885254 7.49586009979248 C 21.55743026733398 8.735569953918457 21.55743026733398 10.26443958282471 20.83970069885254 11.50413990020752 L 17.65549087524414 17.00414085388184 C 16.94034004211426 18.23941040039062 15.62113952636719 19 14.19379043579102 19 L 7.806209564208984 19 C 6.378860473632812 19 5.059659957885742 18.23941040039062 4.344499588012695 17.00414085388184 L 1.160289764404297 11.50413990020752 C 0.4425697326660156 10.26443004608154 0.4425697326660156 8.735560417175293 1.160299301147461 7.495849609375 L 4.344509124755859 1.995849609375 C 5.059659957885742 0.760589599609375 6.378860473632812 0 7.806209564208984 0 Z",
    stroke: "none",
    fill: "#757788"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28875",
    "data-name": "Group 28875",
    transform: "translate(-58.975 277.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65883",
    "data-name": "Path 65883",
    d: "M100.156,136.431h2.75a1.8,1.8,0,0,0,1.8-1.8h0a1.8,1.8,0,0,0-1.8-1.8h-.948a1.8,1.8,0,0,1-1.8-1.8h0a1.8,1.8,0,0,1,1.8-1.8h2.749",
    transform: "translate(-2.493 -1.835)",
    fill: "none",
    stroke: "#757788",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5059",
    "data-name": "Line 5059",
    y2: 1.748,
    transform: "translate(99.939 134.596)",
    fill: "none",
    stroke: "#757788",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5060",
    "data-name": "Line 5060",
    y2: 1.748,
    transform: "translate(99.939 125.644)",
    fill: "none",
    stroke: "#757788",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/Finances.51ed98d6c2f28726dad95f5a1259406d.svg";
export { ForwardRef as ReactComponent };